import React, {useEffect, useState} from "react"
import MetaTags from "react-meta-tags"
import {Container, Card, CardBody, Nav, NavItem, NavLink} from "reactstrap"
import classnames from "classnames"
import {withRouter} from "react-router"
import {withTranslation} from "react-i18next"
import PropTypes from "prop-types"
import DataTableImportListeEtudiantOrientation from "./DataTableImportListeEtudiantOrientation"

const ImportEtudiantOrientation = props => {
    const [section, setSection] = useState(1)

    const back = () => {
        setSection(1)
    }

    const renderBlock = section => {
        if (section === 1) {
            return <DataTableImportListeEtudiantOrientation/>
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{props.t("Import Etudiant Orientation")} | Cresus </title>
                </MetaTags>
                <Container fluid>
                    <div>
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    style={{cursor: "pointer"}}
                                    className={classnames({
                                        active: section === 1,
                                    })}
                                    onClick={() => {
                                        setSection(1)
                                    }}
                                >
                                    {props.t("Import Etudiant Orientation")}
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <Card>
                            <CardBody>{renderBlock(section)}</CardBody>
                        </Card>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(withTranslation()(ImportEtudiantOrientation))
ImportEtudiantOrientation.propTypes = {
    t: PropTypes.any,
}
